import React from 'react';
import {LeaderboardItemType} from '../../types';
import {Image} from 'antd-mobile';
import {toPriceStr} from '@components/utils';

const defaultUser2 = require('../../assets/user-default-2.svg').default;

interface FissionLeaderboardItemProps {
  item: LeaderboardItemType;
}

const FissionLeaderboardItem: React.FC<FissionLeaderboardItemProps> = ({
  item,
}) => {
  return (
    <div className="bg-white rounded-lg py-2 px-3 shadow-sm">
      <div className="flex items-center gap-3">
        {/* Ranking */}
        <div className="flex items-center w-8 justify-center">
          <span className="text-lg font-semibold text-[#02221D]">
            {item.rank}
          </span>
        </div>

        {/* User Information */}
        <div className="flex-1 flex">
          <div className="flex items-center">
            <Image
              src={item.avatar || defaultUser2}
              className="rounded-full w-[2.375rem] h-[2.375rem] mr-3"
              fit="cover"
            />
            <div>
              <div className="text-xs text-[#02221D] font-medium mb-1">
                {item.username || '--'}
              </div>
              <div className="flex items-center gap-1.5">
                <Image
                  src={require('../../assets/person.webp')}
                  className="w-5 h-4"></Image>
                <span className="text-[#F3860A] font-bold text-base">
                  {item.point || '--'}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Estimated Amount */}
        <div className="flex-1 flex items-center justify-end">
          <div className="flex items-center">
            <div className="w-6 h-6 bg-yellow-400 rounded-full mr-2 flex items-center justify-center">
              <Image
                src={require('../../assets/coin.webp')}
                className="size-5"></Image>
            </div>
            <span className="text-orange-500 font-bold text-lg">
              {item.bonus
                ? toPriceStr(item.bonus, {
                    showCurrency: true,
                    overPrice: 10000,
                    suffixUnit: 'K',
                  })
                : '--'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FissionLeaderboardItem;
